import React from "react";
import { motion } from "framer-motion";
import { useAppearanceDelay } from "../lib/react";
import { Spinner } from "./spinner";

export function FullPageSpinner({ isLoading = true }) {
  const show = useAppearanceDelay(isLoading);

  if (show) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="tbk-absolute tbk-inset-0 tbk-z-10 tbk-flex tbk-items-center tbk-justify-center tbk-bg-basic-white"
      >
        <Spinner
          className="tbk-h-5 tbk-w-5 tbk-text-primary"
          aria-label="Loading page"
        />
      </motion.div>
    );
  }

  return null;
}
